import utils from "./utils";
var applyDomainParam = function (params) {
  if (!params) {
    return params;
  }
  var domainurl = null;

  // 识别当前是否在本地开发环境
  var currentHost = window.location.host;
  var isLocal = currentHost.indexOf('localhost') === 0 ||
                currentHost.indexOf('127.0.0.1') === 0 ||
                currentHost.indexOf('192.168.') === 0;

  if (params.adddomain) {
    // 规则：本地开发环境不传 domain
    if (!isLocal) {
      // 优先级 1: 从 Referrer 获取 (适用于大部分 iframe 场景)
      if (document.referrer) {
        try {
          var refUrl = new URL(document.referrer);
          if (refUrl.origin && refUrl.origin !== 'null') {
            domainurl = refUrl.origin + '/';
          }
        } catch (e) {
          domainurl = document.referrer;
        }
      }

      // 优先级 2: 如果 Referrer 失败，尝试使用 ancestorOrigins (Chrome/Safari 兼容)
      if ((!domainurl || domainurl === 'null') && window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
        domainurl = window.location.ancestorOrigins[0] + '/';
      }

      // 优先级 3: 最后的兜底，使用 URL 参数中自带的 domain (如果有的话)
      if (!domainurl || domainurl === 'null') {
        domainurl = params.domain;
      }

      // 如果拿到了有效的域名，则设置它
      if (domainurl && domainurl !== 'null') {
        params.domain = domainurl;
      }
    } else {
      // 本地环境，强制移除 domain 参数
      delete params.domain;
    }
  }
  return params;
};

var resolveParams = function (params, extra) {
  var result = [];
  var timestamp = (extra && extra.timestamp) || 1 * new Date();

  // 统一处理 domain
  applyDomainParam(params);

  // 3. 构建最终的参数字符串
  var queryParts = [];
  for (var key in params) {
    // 排除 adddomain (开关) 和 location (业务要求放最后)
    if (params.hasOwnProperty(key) && key !== 'adddomain' && key !== 'location') {
      var value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        queryParts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    }
  }

  // 4. 添加 sign 和 time
  if (extra && extra.sign) {
    queryParts.push('sign=' + extra.sign);
  }
  queryParts.push('time=' + timestamp);

  // 5. 最后添加 location
  if (params.location !== undefined) {
    queryParts.push('location=' + encodeURIComponent(params.location));
  }

  return queryParts.join('&');
};
// 动态判断环境（函数方式，支持运行时判断）
const getTestDomain = function() {
  // 优先使用 postMessage 传递的环境信息（srcdoc 模式）
  if (window._ZHINI_ENV && window._ZHINI_ENV.isLocalDev) {
    return true;
  }
  if (window._ZHINI_ENV && window._ZHINI_ENV.baseUrl) {
    var baseUrl = window._ZHINI_ENV.baseUrl;
    if (baseUrl.indexOf('test.qunsou.co/plugin/') !== -1) {
      return true;
    }
    if (baseUrl.indexOf('zhiniplugin.h5bqb.top/customer/widget/') !== -1) {
      return false;
    }
  }
  // 降级：使用 window.location 判断（传统模式）
  // 如果在 iframe 中且 hostname 为空，尝试从父页面获取
  var hostname = window.location.hostname || '';
  if (!hostname && window.parent && window.parent !== window) {
    try {
      hostname = window.parent.location.hostname || '';
    } catch (e) {
      // 跨域时无法访问，忽略错误
    }
  }
  var result = hostname === "test.qunsou.co";
  return result;
};

const resovleDomain = (params) => {
  if (params.thirdDomain) {
    return;
  }
  params.url =
      (getTestDomain() ? "https://test.qunsou.co" : "https://apiplugin.h5bqb.top") +
      params.url;
};
var a =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
          return typeof e;
        }
        : function (e) {
          return e &&
          "function" == typeof Symbol &&
          e.constructor === Symbol &&
          e !== Symbol.prototype
              ? "symbol"
              : typeof e;
        };
const httpRequest = (params) => {
  resovleDomain(params);
  params.type = (params.type || "GET").toUpperCase();
  params.dataType = params.dataType || "json";
  params.contentType =
      params.contentType || "application/x-www-form-urlencoded; charset=UTF-8";
  let httpMethod;
  if ("undefined" != typeof XMLHttpRequest) {
    httpMethod = new XMLHttpRequest();
  } else {
    for (
        let i = [
              "Microsoft.XmlHttp",
              "MSXML2.XmlHttp",
              "MSXML2.XmlHttp.3.0",
              "MSXML2.XmlHttp.4.0",
              "MSXML2.XmlHttp.5.0",
              "MSXML2.XmlHttp.6.0",
            ],
            o = 0,
            l = i.length;
        o < l;
        o++
    ) {
      try {
        httpMethod = new ActiveXObject(i[o]);
        break;
      } catch (c) {}
    }
  }
  httpMethod.onreadystatechange = function () {
    if (4 === httpMethod.readyState) {
      var status = httpMethod.status;
      if (status >= 200 && status < 300) {
        var res = httpMethod.responseText;
        try {
          "json" === params.dataType && res && (res = JSON.parse(res));
        } catch (c) {}
        if (res.sta == 0) {
          params.success && params.success(res, httpMethod.responseXML);
        } else {
          params.error && params.error(res, status, httpMethod);
        }
      } else {
        params.error && params.error(httpMethod.responseText, status, httpMethod);
      }
    }
  };
  if ("GET" === params.type) {
    httpMethod.open("GET", params.url + "?" + resolveParams(params.data), !0);
    httpMethod.send(null);
  } else if ("POST" === params.type) {
    httpMethod.open("POST", "" + params.url, !0);
    !params.fileType &&
    httpMethod.setRequestHeader("Content-Type", params.contentType);
    var u = params.header;
    if (u) {
      for (var f in u) {
        httpMethod.setRequestHeader(f, u[f]);
      }
    }
    var h = params.data;
    if ("object" === ("undefined" == typeof h ? "undefined" : a(h)) && !params.fileType) {
      if (params.contentType && params.contentType.indexOf("application/json") !== -1) {
        applyDomainParam(h);
        delete h.adddomain;
        h = JSON.stringify(h);
      } else {
        h = JSON.stringify(h);
      }
    }
    httpMethod.send(h);
  }
  return params.beforeSend && params.beforeSend(httpMethod), httpMethod;
};
const changeInputImg = (token, files, base64, msgItem, cb) => {
  let curFile;
  let imgFile;
  if (base64) {
    curFile = files.blob;
    imgFile =
        curFile.type &&
        curFile.type.indexOf("image") > -1 &&
        curFile.type.indexOf("svg") < 0;
  } else {
    if (files.length == 0) {
      cb(600, { msg: "上传失败，请重新上传！", errcode: 600 });
      return;
    }
    curFile = files[0];
    imgFile =
        curFile &&
        curFile.type &&
        curFile.type.indexOf("image") > -1 &&
        curFile.type.indexOf("svg") < 0;
    const videoFile = utils.isVideoFile(curFile.name)

    // 图片限制10M
    if (imgFile && (!curFile || curFile.size > 10 * 1024 * 1024)) {
      cb(600, { msg: "图片的大小不能超过10M！", errcode: 600 });
      return;
    }

    // 视频限制25M
    if(videoFile && (!curFile || curFile.size > 25 * 1024 * 1024)){
      cb(600, { msg: "视频的大小不能超过25M！", errcode: 600 });
      return;
    }

    // 文件限制25M
    if (!imgFile && !videoFile && (!curFile || curFile.size > 25 * 1024 * 1024)) {
      cb(600, { msg: "文件的大小不能超过25M！", errcode: 600 });
      return;
    }
  }

  const data = new FormData();
  data.append("file", curFile);
  data.append("ftype", imgFile ? "image" : utils.isVideoFile(curFile.name) ? 'video' : "file");
  data.append("fsize", curFile.size);
  if(msgItem && msgItem.msgtype == "video" && msgItem.width == 0 && msgItem.height == 0){
    data.append("return_thumb", true);
  }

  let channel_id = utils.getParameterByName("channel_id");
  let client_id =  utils.getParameterByName("init_client_id_" + channel_id) || utils.getParameterByName("client_id_" + channel_id)
  let add_params = `&channel_id=${channel_id}&client_id=${client_id}&ftype=${imgFile ? "image" : utils.isVideoFile(curFile.name) ? 'video' : "file"}`
  httpRequest({
    type: "POST",
    url: "/wykf/api/v1/enterprise/webplugin/upload?version=0.1.3&token=" + token + add_params,
    data: data,
    fileType: true,
    success: (result) => {
      cb(0, result.data[0]);
    },
    error: (res) => {
      cb(-1, {
        msg: res.msg || (imgFile ? "图片" : utils.isVideoFile(curFile.name) ? "视频" : "文件") + "上传失败！",
        errcode: res.sta,
        token
      });
    },
  });
};
export default {
  httpRequest,
  changeInputImg,
  getTestDomain,
};



// WEBPACK FOOTER //
// ./src/js/ajaxutils.js